import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(config);

    /** @ngInject */
    function config(
        toastrConfig,
        $httpProvider,
        $locationProvider,
        cfpLoadingBarProvider,
        ChartJsProvider
    ) {
        // HTML5 mode in urls e.g. /kontakt instead of /#/kontakt
        $locationProvider.html5Mode(true);

        $httpProvider.interceptors.push('SessionInjectorFactory');
        $httpProvider.defaults.xsrfCookieName = 'csrftoken';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = false;
        toastrConfig.progressBar = true;

        cfpLoadingBarProvider.includeSpinner = false;

        ChartJsProvider.setOptions({
            responsive: false,
            chartColors: ['#18a9ec'],
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/index.config.ts